import { useQuery } from '@tanstack/react-query';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { ICoMedicationChecklist } from '../OTP';

export function useCoMedicationChecklist(otpId: number | undefined) {
    return useQuery<ICoMedicationChecklist>({
        queryKey: [QueryKeys.otpCoMedications, otpId],
        queryFn: () => OTPApi.getCoMedicationChecklist(otpId!),
        enabled: !!otpId,
    });
}
